module.exports = __webpack_public_path__ + "img/djifly_1.7642da07.jpg";